import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/dashboard'
import { dashboardKeys } from '@core/react-query/features/dashboard'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  IInspectionStats,
  InspectionStats,
} from '@core/entities/dashboard/inspectionStats'

const dataTransformer = (inspectionStats: IInspectionStats) =>
  InspectionStats.new(inspectionStats)

export const useGetDashboardInspectionStats = (
  payload: RequestTypes['getDashboardInspectionStats'],
  options?: UseQueryOptions<
    IInspectionStats,
    RequestErrorType,
    InspectionStats
  >,
) => {
  return useQuery({
    select: dataTransformer,
    ...dashboardKeys.getDashboardInspectionStats(payload),
    ...options,
  })
}
